<template>
  <div class="home">
    <PanelGrid />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";

// Lazy-load PanelGrid so its module (and usePanels inside it) is not evaluated
// until the component is actually rendered. This prevents panels from
// loading for users who are not authorized (since router guards handle this now).
const PanelGrid = defineAsyncComponent(() => import("@/components/PanelGrid.vue"));
</script>

<style scoped>
.home {
  padding: 1rem;
  text-align: left;
}

pre {
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  padding: 1rem;
  border-radius: 4px;
  white-space: pre-wrap; /* Wrap long lines */
  word-wrap: break-word; /* Break words if necessary */
}
</style>
